export default __webpack_public_path__ + "static/media/locations-header.05c37331.jpg";